export default __webpack_public_path__ + "media/images/74-0936f4c655e42f6f8152f8ae156e4adc.jpg";